import React, {useContext} from 'react';
import { bool } from 'prop-types';
import { injectIntl, FormattedHTMLMessage } from 'gatsby-plugin-intl';
import { StyledMenu, MenuList, Item, MenuBtn, MobMenuHeader, MobMenuHeaderRow, HelpBlock } from './Menu.styled';
import { useBreakpoint } from 'gatsby-plugin-breakpoints';
import AuthContext from '../../context/AuthContext';
import ModalContext from '../../context/ModalContext';

import { LanguageSwitcherMob } from '../LanguageSwitcher';
import LoginBtn from '../../styledComponents/LoginBtn';
import LogoutBtn from '../../styledComponents/LogoutBtn';

const Menu = ({ intl, openNav, setOpenNav, refs, handleCLick, ...props }) => {

    const breakpoints = useBreakpoint();

    const authcontext = useContext(AuthContext);

    const isHidden = openNav ? true : false;
    const tabIndex = isHidden ? 0 : -1;

    return (
        <StyledMenu openNav={openNav} aria-hidden={!isHidden} {...props}>
            {breakpoints.maxMd && 
                <MobMenuHeader>
                    <MobMenuHeaderRow>
                    <LanguageSwitcherMob />
                        {authcontext.data.loginMode 
                        ? 
                            <>
                                <AuthContext.Consumer>
                                    {({updateLoginMode}) => (
                                    <LogoutBtn onClick={updateLoginMode}>
                                        {intl.formatMessage({ id: 'logout_btn' })}
                                    </LogoutBtn>
                                    )}
                                </AuthContext.Consumer>
                            </>
                            : 
                            <>
                                <ModalContext.Consumer>
                                    {({updateModalMode}) => (
                                    <LoginBtn onClick={updateModalMode}>
                                        {intl.formatMessage({ id: 'login_btn' })}
                                    </LoginBtn>
                                    )}
                                </ModalContext.Consumer>
                            </>
                        }
                    </MobMenuHeaderRow>
                    {authcontext.data.loginMode &&
                        <HelpBlock><FormattedHTMLMessage id="help_text" /></HelpBlock>
                    }
                </MobMenuHeader>
            }
            
            <MenuList>
                <Item>
                    <MenuBtn 
                        data-section="brand-section"
                        onClick={() => {handleCLick('brandSection'); setOpenNav(!openNav)}}
                        tabIndex={tabIndex}>{intl.formatMessage({ id: 'brand_title' })}</MenuBtn>
                    <MenuBtn 
                        data-section="productTalk-section"
                        onClick={() => {handleCLick('productTalkSection'); setOpenNav(!openNav)}}
                        tabIndex={tabIndex}>{intl.formatMessage({ id: 'productTalk_title' })}</MenuBtn>
                    <MenuBtn 
                        data-section="logo-section"
                        onClick={() => {handleCLick('logoSection'); setOpenNav(!openNav)}}
                        tabIndex={tabIndex}>{intl.formatMessage({ id: 'MainMenu_1' })}</MenuBtn>
                    <MenuBtn 
                        data-section="color-section"
                        onClick={() => {handleCLick('colorSection'); setOpenNav(!openNav)}}
                        tabIndex={tabIndex}>{intl.formatMessage({ id: 'MainMenu_2' })}</MenuBtn>
                    <MenuBtn
                        data-section="typography-section"
                        onClick={() => {handleCLick('typographySection'); setOpenNav(!openNav)}}
                        tabIndex={tabIndex}>{intl.formatMessage({ id: 'MainMenu_3' })}</MenuBtn>
                    <MenuBtn
                        data-section="devices-section"
                        onClick={() => {handleCLick('devicesSection'); setOpenNav(!openNav)}}
                        tabIndex={tabIndex}>{intl.formatMessage({ id: 'MainMenu_4' })}</MenuBtn>
                    <MenuBtn
                        data-section="works-section"
                        onClick={() => {handleCLick('worksSection'); setOpenNav(!openNav)}}
                        tabIndex={tabIndex}>{intl.formatMessage({ id: 'MainMenu_6' })}</MenuBtn>
                    <MenuBtn
                        data-section="merch-section"
                        onClick={() => {handleCLick('merchSection'); setOpenNav(!openNav)}}
                        tabIndex={tabIndex}>{intl.formatMessage({ id: 'MainMenu_7' })}</MenuBtn>
                    <MenuBtn
                        data-section="equipment-section"
                        onClick={() => {handleCLick('equipmentSection'); setOpenNav(!openNav)}}
                        tabIndex={tabIndex}>{intl.formatMessage({ id: 'MainMenu_8' })}</MenuBtn>
                    <MenuBtn
                        data-section="design-section"
                        onClick={() => {handleCLick('designSection'); setOpenNav(!openNav)}}
                        tabIndex={tabIndex}>{intl.formatMessage({ id: 'MainMenu_10' })}</MenuBtn>
                    <MenuBtn
                        data-section="designConstructor-section"
                        onClick={() => {handleCLick('designConstructorSection'); setOpenNav(!openNav)}}
                        tabIndex={tabIndex}>{intl.formatMessage({ id: 'designConstr_title' })}</MenuBtn>
                    <MenuBtn
                        data-section="icons-section"
                        onClick={() => {handleCLick('iconsSection'); setOpenNav(!openNav)}}
                        tabIndex={tabIndex}>{intl.formatMessage({ id: 'MainMenu_9' })}</MenuBtn>
                </Item>
            </MenuList>
        </StyledMenu>
    )
}

Menu.propTypes = {
    openNav: bool.isRequired,
}

export default injectIntl(Menu);